import { supertypeClass, property, Persistable, Remoteable, Supertype } from '@haventech/amorphic';
import { Policy } from './Policy';

@supertypeClass({ toClient: true, toServer: true })
export class PremiumLoan extends Persistable(Remoteable(Supertype)) {
  constructor() {
    super();
  }

  static new(policy: Policy) {
    return new PremiumLoan().init(policy);
  }

  init(policy: Policy) {
    this.policy = policy;
    return this;
  }

  @property({ getType: () => Policy })
  policy: Policy;

  @property({
    rule: 'required',
    comment: 'The lending body of the loan',
  })
  lender: string;

  @property({
    rule: 'required',
    comment: 'The duration of the loan',
  })
  duration: string;

  @property({
    rule: 'required',
    comment: 'The interest rate of the loan',
  })
  interestRate: string;

  @property({
    rule: 'required',
    comment: 'A description of the collateral used for the loan',
  })
  collateralDetails: string;

  @property({
    rule: 'required',
    comment: 'A description of the charges and/or fees of the loan',
  })
  chargesOrFeesDetails: string;

  @property({
    rule: 'required',
    comment: 'Whether or not the loan has a prepayment penalty',
  })
  hasPrepaymentPenalty: string;

  @property({
    rule: 'required',
    comment: 'Whether or not the loan has a penalty if not repayed within a timely manner',
  })
  hasTimePenalty: string;

  @property({
    rule: 'required',
    comment: 'The principal of the loan',
  })
  principal: string;

  @property({
    rule: 'required',
    comment: 'The interest payment of the loan',
  })
  interestPayment: string;

  @property({
    rule: 'required',
    comment: 'Whether the loan is owned by a captive insurance company',
  })
  isOwnedByCaptiveCompany: string;

  @property({
    rule: 'required',
    comment:
      'Whether any of the premium payments of the loan will be payed from assets or contributions from a captive insurance company',
  })
  isAnyPaymentFromCaptiveCompany: string;
}
